/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Show,
} from '../models/index';
import {
    ShowFromJSON,
    ShowToJSON,
} from '../models/index';

export interface ApiShowIdGetRequest {
    id: number;
}

/**
 * 
 */
export class ShowApi extends runtime.BaseAPI {

    /**
     */
    async apiShowIdGetRaw(requestParameters: ApiShowIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiShowIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Show/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     */
    async apiShowIdGet(requestParameters: ApiShowIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.apiShowIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
